<template>
  <payment-information-form :id="id" @submit-new="onSubmitFromNew" @submit-edit="onSubmitFromEdit" @cancel="onSubmit" />
</template>

<script>
import PaymentInformationForm from '@/components/ec-line013/PaymentInformationForm.vue'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  props: {
    id: { type: [Number, String], default: () => null },
  },
  mixins: [BreadcrumbMixin],
  components: { PaymentInformationForm },

  methods: {
    onSubmitFromNew() {
      this.$alert({
        message: this.$t('ec-line013.content.addCardSuccess'),
        type: 'success',
      })
      this.onSubmit()
    },
    onSubmitFromEdit() {
      this.$alert({
        message: this.$t('ec-line013.content.updateCardSuccess'),
        type: 'success',
      })
      this.onSubmit()
    },
    onSubmit() {
      const { redirect, popup } = this.$route.query

      if (redirect) {
        this.$router.push({
          path: redirect,
          query: {
            popup,
          },
        })
      } else {
        this.$router.push(this.$routePage.EC_LINE012)
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line013.title'),
      script: [
        {
          src: process.env.VUE_APP_GMO_LIB_URL,
        },
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.id
            ? this.$t('ec-line013.editDescription', { shop_name: this.shopName })
            : this.$t('ec-line013.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.id
            ? this.$t('ec-line013.editKeyword', { shop_name: this.shopName })
            : this.$t('ec-line013.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>
